import { useParams } from "react-router-dom";

export function useParam<TKey extends string, TReturn>(
  key: TKey,
  fn: (v: any) => TReturn,
) {
  return fn(useParams<{ [key in TKey]: string }>()[key]);
}
